import React, { useRef } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../../store";
import { useReactToPrint } from "react-to-print";
import { DownloadResume } from "../resume_output";

const Resume3 = observer(() => {
  const { ResumeStore } = useStores();

  const resumeRef = useRef(null);

    const handleDownload = useReactToPrint({
      content: () => resumeRef.current,
    });

  return (
   <>
   <DownloadResume onClick={handleDownload}/>
    <div className="max-w-4xl  mx-[5%] mt-10 bg-white shadow-lg rounded-lg overflow-hidden" ref={resumeRef}>
      <div className="bg-green-500 text-white text-center py-6 border-b-4 border-green-700">
        <h1 className="text-3xl">
          {ResumeStore?.resumeBuilder?.personalDetails?.firstName} {ResumeStore?.resumeBuilder?.personalDetails?.lastName}
        </h1>
        <p className="text-lg">{ResumeStore?.resumeBuilder?.personalDetails?.jobTitle}</p>
        <div className="text-sm mt-2">
          <p className="text-center justify-center">
            <strong>Phone:</strong> {ResumeStore?.resumeBuilder?.personalDetails?.phone} | <strong>Email:</strong> {ResumeStore?.resumeBuilder?.personalDetails?.email} | <strong>Address:</strong> {ResumeStore?.resumeBuilder?.personalDetails?.address}, {ResumeStore?.resumeBuilder?.personalDetails?.city}
          </p>
        </div>
      </div>
      <div className="flex p-6">
        <div className="w-1/3 pr-4 border-r border-gray-300">
          <div className="mb-6">
            <img
              src={ResumeStore?.resumeBuilder?.profile || 'https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww'}
              alt="Profile"
              className="w-[100px] md:w-[200px] h-[100px] md:h-[200px] mx-auto max-h-52 rounded-full shadow-md mb-4"
            />
            <h3 className="text-lg text-green-500 border-b-2 border-green-500 pb-1 mb-4">Skills</h3>
            <ul className=" list-inside text-sm">
              {ResumeStore?.resumeBuilder?.skills?.map((skill, index) => (
                <li key={index} className="flex items-center justify-start">
                    <span style={{ color: '#10b981' }} className="text-3xl">•</span> {/* Change '#10b981' to your desired color */}
                    <span style={{ marginLeft: '0.5em' }}>{skill}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="mb-6">
            <h3 className="text-lg text-green-500 border-b-2 border-green-500 pb-1 mb-4">Hobbies</h3>
            <ul className="list-disc list-inside text-sm">
              {ResumeStore?.resumeBuilder?.hobbies?.map((hobby, index) => (
                <li key={index} className="flex items-center justify-start">
                    <span style={{ color: '#10b981' }} className="text-3xl">•</span> {/* Change '#10b981' to your desired color */}
                    <span style={{ marginLeft: '0.5em' }}>{hobby}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="w-2/3 pl-4">
          <div className="mb-6">
            <h3 className="text-lg text-green-500 border-b-2 border-green-500 pb-1 mb-4">Profile</h3>
            <p className="text-sm">{ResumeStore?.resumeBuilder?.profileSummary}</p>
          </div>
          <div className="mb-6">
            <h3 className="text-lg text-green-500 border-b-2 border-green-500 pb-1 mb-4">Experience</h3>
            {ResumeStore?.resumeBuilder?.employementHistory?.map((job, index) => (
              <div key={index} className="mb-4">
                <p className="font-semibold text-sm">
                  {job.jobTitle} | {job.company} | {job.startDate} - {job.endDate}
                </p>
                <p className="text-sm">{job.description}</p>
              </div>
            ))}
          </div>
          <div className="mb-6">
            <h3 className="text-lg text-green-500 border-b-2 border-green-500 pb-1 mb-4">Education</h3>
            {ResumeStore?.resumeBuilder?.education?.map((edu, index) => (
              <div key={index} className="mb-4">
                <p className="font-semibold text-sm">
                  {edu.degree} | {edu.school} | {edu.startDate} - {edu.endDate}
                </p>
                <p className="text-sm">{edu.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    </>
  );
});

export default Resume3;
